var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-main common" },
    [
      _c(
        "a-steps",
        { staticClass: "common-step", attrs: { current: _vm.current } },
        _vm._l(_vm.steps, function(item) {
          return _c("a-step", { key: item.title, attrs: { title: item.title } })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "keep-alive",
            [
              _c(_vm.steps[_vm.current].comp, {
                ref: "modify",
                tag: "component",
                attrs: { noInit: _vm.noInit, text: _vm.steps[_vm.current].text }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "model-footer-btns spaceCenter" },
        [
          _vm.current == 0
            ? _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  staticStyle: { "margin-left": "8px" },
                  on: { click: _vm.goback }
                },
                [_vm._v("\n            取消\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.current > 0 && _vm.current < _vm.steps.length - 1
            ? _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  staticStyle: { "margin-left": "8px" },
                  on: { click: _vm.prev }
                },
                [_vm._v("\n            上一步\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.current < _vm.steps.length - 2
            ? _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  attrs: { type: "primary" },
                  on: { click: _vm.next }
                },
                [_vm._v("\n            下一步\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.current == _vm.steps.length - 2
            ? _c(
                "a-button",
                {
                  staticClass: "btn-big",
                  attrs: { type: "primary" },
                  on: { click: _vm.success }
                },
                [_vm._v("\n            确认\n        ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.current == _vm.steps.length - 1
            ? _c(
                "a-button",
                { staticClass: "btn-big", on: { click: _vm.goback } },
                [_vm._v("\n            返回登录页面\n        ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58232edc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58232edc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/security/main/pswd-modify.vue
// module id = E0/g
// module chunks = 1